const baseUrl = process.env.REACT_APP_API + "/api";

export const DEVICETYPE_URL = baseUrl + "/device-type";
export const CHECKLIST_EXECUTION_URL = baseUrl + "/checklist-executions";
export const QUALITY_PROCEDURE_BUILDER_URL = baseUrl + "/procedure-builder";
export const QUALITY_PLAN_EXECUTION_URL = baseUrl + "/quality-plan-executions";
